import { applicationPdfDocumentTitles, applicationPdfDownloadOnlyTitles, InputType } from 'config'

export const defaultInputs = (): Record<string, InputType> => {
  return {
    agreeToSign: {
      inputType: 'toggle',
      title: 'I agree to the terms and conditions.',
      value: false,
      required: true,
    },
    informationToSign: {
      inputType: 'textarea',
      title: 'Other information you wish to provide that may be relevant to this loan application',
      required: false,
    },
  }
}

export const commercialInputs = (): Record<string, InputType> => {
  return {
    institution: {
      title: 'Financial Institution',
      inputType: 'text',
      value: '',
      error: '',
      required: true,
    },
    accountNumber: {
      title: 'Account Number',
      type: 'bankAccountNo',
      inputType: 'text',
      minLength: 8,
      maxLength: 17,
      value: '',
      error: '',
      required: true,
    },
    accountType: {
      title: 'Account Type',
      inputType: 'Select',
      value: '',
      options: ['Checking', 'Saving'],
      hasDefaultOption: true,
      required: true,
      error: '',
    },
    ABANumber: {
      title: 'ABA Routing Number',
      inputType: 'text',
      value: '',
      error: '',
      type: 'routingNo',
      required: true,
    },
  }
}

export const documentTitles = applicationPdfDocumentTitles
export const downloadOnlyDocumentTitles = applicationPdfDownloadOnlyTitles

export const documentInputs = (): Record<string, InputType> => {
  const inputs = Object.keys(documentTitles).reduce((acc, key) => {
    acc[key] = {
      inputType: 'checkbox',
      title: documentTitles[key],
      value: true,
    }
    return acc
  }, {} as Record<string, InputType>)

  Object.keys(downloadOnlyDocumentTitles).forEach((key) => {
    inputs[key] = {
      inputType: 'checkbox',
      title: downloadOnlyDocumentTitles[key],
      value: false,
    }
  })

  return inputs
}

export enum LoanSignHistoryStatus {
  Pending = 'Pending',
  Signed = 'Signed',
  Canceled = 'Canceled',
}

// Fixed numeric keys for hardcoded Sign Application action buttons.
// These must be numeric so backend `isCustomFieldKey` routes them to
// loan.customInformation and the existing `loan.field.updated` history fires.
export const SIGN_ACTION_KEYS = {
  viewSignedApplicationPdf: '1700000001000',
  sendSignatureRequest: '1700000002000',
  viewUnsignedApplicationPdf: '1700000003000',
  signApplication: '1700000004000',
} as const

export const SIGN_ACTION_SLUGS = {
  [SIGN_ACTION_KEYS.viewSignedApplicationPdf]: 'viewSignedApplicationPdf',
  [SIGN_ACTION_KEYS.sendSignatureRequest]: 'sendSignatureRequest',
  [SIGN_ACTION_KEYS.viewUnsignedApplicationPdf]: 'viewUnsignedApplicationPdf',
  [SIGN_ACTION_KEYS.signApplication]: 'signApplication',
} as const

export const signDefaultFieldKeys = [
  'template',
  'originatorInformation',
  SIGN_ACTION_KEYS.viewSignedApplicationPdf,
  SIGN_ACTION_KEYS.sendSignatureRequest,
  SIGN_ACTION_KEYS.viewUnsignedApplicationPdf,
  SIGN_ACTION_KEYS.signApplication,
]
